import React from 'react'
import dompurify from 'dompurify'
import { Dialog } from '@progress/kendo-react-dialogs'
import { useTranslation } from "react-i18next"

import htmlContent from '../../../utils/termsandconditions'


/* === Custom component title for dialog error === */
const CustomTitleBar = () => {
  const { t } = useTranslation()

  const customTitleBarStyles = {
    color: '#FFFFFF',
    fontSize: '20px',
    textAlign: 'left',
    fontFamily: 'Quicksand, sans-serif',
    fontWeight: '600'
  }
  return (<div style={customTitleBarStyles}><span>{t('dialogSignRequestPure.titleDialogSignRequest')}</span></div>)
}


/**
 *
 * @param {*} props
 * @return {*} 
 * @status no delete
 */
function DialogTermsCond(props) {
  var sanitizer = dompurify.sanitize

  return (
    <>
      {props.modalTermsCond &&
        <Dialog title={<CustomTitleBar />} onClose={() => { props.openModalTermsCond(false) }} height={500} width={750}>
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '20px' }}>
            {/* <div dangerouslySetInnerHTML={{ __html: sanitizer(htmlContent) }} /> */}
            <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
          </div>
        </Dialog>
      }
    </>
  )
}
export { DialogTermsCond as default }